<template>
  <div style="width: 1200px;margin: 0 auto;margin-top:10px;">
    <div v-if="oborShow" id="myTabContent" class="tab-content">
      <div
        class="tab-pane fade in active markdown-body editormd-html-preview"
        style="display: block; box-sizing: border-box; line-height: 30px;box-shadow: 0px 0px 12px #888888;padding: 20px 40px;"
      >
        <div style="color:#4996dd;font-size:15px;font-weight: 600;cursor: pointer;" @click="back">返回</div>
        <h3 style="text-align:center">指数简介</h3>
        <p>
          为全面、及时反映“一带一路”建设成果，特别是在贸易畅通和交通运输方面的发展成效，上海航运交易所研发了 “一带一路”货运贸易指数和“海上丝绸之路”运价指数。经过2年的试运行，在原指数的基础上，进一步调整优化了指数结构，于2017年7月正式对外发布“一带一路”航贸指数。该指数由“一带一路”贸易额指数、“一带一路”货运量指数、“海上丝绸之路”运价指数等3大类指数组成。
        </p>
        <p>2021年1月，上海航运交易所进一步优化指数结构，将原“一带一路”货运量指数更改为“一带一路”集装箱海运量指数，和“一带一路”贸易额指数、“海上丝绸之路”运价指数共同组成“一带一路”航贸指数。</p>
        <h3>
          <a name="一、指数构成" class="reference-link"></a>
          <span class="header-link octicon octicon-link"></span>一、指数构成
        </h3>
        <p>“一带一路”贸易额指数包含1个综合指数，8个成分指数。涵盖“一带一路”沿线上66个国家，分布于北亚、中亚、南亚、东南亚、西亚、北非、欧洲和大洋洲等地区。</p>
        <p>
          原“一带一路”货运量指数包含1个综合指数，5个成分指数（分别是中国至“一带”沿线国家铁路货运出口量指数，中国（上海）至“一路”沿线国家出口集装箱海运量指数，中国自“一路”沿线国家进口煤炭海运量、铁矿石海运量、原油海运量指数）及细分地区指数。“一带”货运量指数反映了中国至丝绸之路经济带沿线蒙俄、中亚、东南亚、欧洲等地区主要国家的铁路货运量变化；“一路”货运量指数反映中国与沿线国家之间煤、矿、油、箱等主要货种海运量变化，涉及“海上丝绸之路”沿线东南亚、
          西亚、南亚、欧洲、大洋洲和北非等多个地区。
        </p>
        <p>“一带一路”集装箱海运量指数包含1个综合指数，2个成分指数（中国（上海）至“一路”沿线国家出口集装箱海运量指数，中国（上海）至“一路”沿线国家进口集装箱海运量指数）及细分地区指数。指数反映了中国与沿线国家集装箱海运量变化情况，涉及“海上丝绸之路”沿线东南亚、 西亚、南亚、欧洲、大洋洲和北非等多个地区。</p>
        <p>“海上丝绸之路”运价指数包括1个综合指数，4个成分指数（分别是“海上丝绸之路”出口集装箱运价指数、进口集装箱运价指数、进口干散货运价指数和进口原油运价指数）及细分航线指数。指数涵盖联通亚非欧的“海上丝绸之路”主要货种、主要航线。</p>
        <h3>
          <a name="二、指数编制" class="reference-link"></a>
          <span class="header-link octicon octicon-link"></span>二、指数编制
        </h3>
        <p style="text-indent: 0px;">
        <!-- <p style="text-indent: 0px;"> -->
          1.基期指数
          <br />指数基期为2015年1月，基期指数为100点。
          <br /><br />2.数据来源
          <br />上海航运交易所采集加工的信息，以及上海航运交易所发布的CCFI、CICFI、CDFI、CTFI等相关航线运价指数。
          <br /><br />3.编制方式
          <br />（1）“一带一路”贸易额指数
          <br />分区域指数：100×当期数据÷基期数据；
          <br />综合指数：分区域指数加权统计；
          <br />（2）原“一带一路”货运量指数
          <br />分区域指数：100×当期数据÷基期数据；
          <br />分类指数：分区域指数加权统计；
          <br />综合指数：分类指数加权统计；
          <br />（3）“一带一路”集装箱指数
          <br />分区域指数：100×当期数据÷基期数据；
          <br />分类指数：分区域指数加权统计；
          <br />综合指数：分类指数加权统计；

          <br />（4）“海上丝绸之路”运价指数
          <br />分航线指数：100×当期数据÷基期数据；
          <br />分类指数： 分航线指数加权统计；
          <br />综合指数： 分类指数加权统计；
        </p>
        <h3>
          <a name="三、发布时间" class="reference-link"></a>
          <span class="header-link octicon octicon-link"></span>三、发布时间
        </h3>
        <p>上海航运交易所在每个月的最后一周星期三(工作日)对外发布指数。指数发布日遇法定节假日等将有所调整，用户可通过登陆上海航运交易所网站了解指数最新信息。</p>
        <p>上海航运交易所在其认为必要且合理的情况下可以延迟或取消发布指数。</p>
        <h5 id="h5--">
          <a name="注:指标涵盖国家范围如下" class="reference-link"></a>
          <span class="header-link octicon octicon-link"></span>注:指标涵盖国家范围如下
        </h5>
        <!-- “一带一路”贸易额指数 -->
        <table>
          <thead>
            <tr>
              <th>&nbsp;</th>
              <th style="text-align:center">“一带一路”贸易额指数</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>指标</td>
              <td style="text-align:center">指标范围</td>
            </tr>
            <tr>
              <td>蒙俄</td>
              <td style="text-align:center">蒙古、俄罗斯联邦等2国</td>
            </tr>
            <tr>
              <td>中亚</td>
              <td style="text-align:center">哈萨克斯坦、吉尔吉斯斯坦、塔吉克斯坦、乌兹别克斯坦、土库曼斯坦等5国</td>
            </tr>
            <tr>
              <td>南亚</td>
              <td style="text-align:center">印度、巴基斯坦、孟加拉国、阿富汗、尼泊尔联邦民主共和国、不丹、斯里兰卡、马尔代夫等8国</td>
            </tr>
            <tr>
              <td>东南亚</td>
              <td style="text-align:center">越南、老挝、柬埔寨、泰国、马来西亚、新加坡、印度尼西亚、文莱、菲律宾、缅甸、东帝汶等11国</td>
            </tr>
            <tr>
              <td>西亚</td>
              <td
                style="text-align:center"
              >土耳其、伊朗、叙利亚、伊拉克、阿联酋、沙特阿拉伯、卡塔尔、巴林、科威特、黎巴嫩、阿曼、也门、约旦、以色列、巴勒斯坦、格鲁吉亚、亚美尼亚、阿塞拜疆等18国</td>
            </tr>
            <tr>
              <td>北非</td>
              <td style="text-align:center">埃及等1国</td>
            </tr>
            <tr>
              <td>欧洲</td>
              <td style="text-align:center">
                波兰、捷克、斯洛伐克、匈牙利、爱沙尼亚、拉脱维亚、立陶宛 、白俄罗斯、乌克兰
                、摩尔多瓦、塞尔维亚、黑山、克罗地亚、斯洛文尼亚 、波黑、前南马其顿、罗马尼亚、保加利亚、阿尔巴尼亚等19国
              </td>
            </tr>
            <tr>
              <td>大洋洲</td>
              <td style="text-align:center">澳大利亚、新西兰等2国</td>
            </tr>
          </tbody>
        </table>
        <p style="margin-bottom：5px!important;font-weight:700;">* 原“一带一路”货运量指数指标涵盖国家范围</p>
        <!-- “一带一路”货运量指数 -->
        <table>
          <thead>
            <tr>
              <th>&nbsp;</th>
              <th style="text-align:center">“一带一路”货运量指数</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>指标</td>
              <td style="text-align:center">指标范围</td>
            </tr>
            <tr>
              <td>中国至“一带”沿线国家铁路货运出口量</td>
              <td style="text-align:center">&nbsp;</td>
            </tr>
            <tr>
              <td>蒙俄</td>
              <td style="text-align:center">蒙古、俄罗斯联邦等2国</td>
            </tr>
            <tr>
              <td>中亚</td>
              <td style="text-align:center">哈萨克斯坦、吉尔吉斯斯坦、塔吉克斯坦、乌兹别克斯坦、土库曼斯坦等5国</td>
            </tr>
            <tr>
              <td>东南亚</td>
              <td style="text-align:center">越南、老挝、柬埔寨、泰国、马来西亚、新加坡、印度尼西亚、文莱、菲律宾、缅甸、东帝汶等11国</td>
            </tr>
            <tr>
              <td>欧洲</td>
              <td
                style="text-align:center"
              >英国、爱尔兰、荷兰、比利时、卢森堡、法国、摩纳哥、冰岛、法罗群岛、丹麦、挪威、瑞典、芬兰、波兰、捷克、斯洛伐克、匈牙利、德国、奥地利、瑞士、列支敦士顿、爱沙尼亚、拉脱维亚、立陶宛、白俄罗斯、乌克兰、摩尔多瓦、塞尔维亚、黑山、克罗地亚、斯洛文尼亚、波黑、马其顿、罗马尼亚、保加利亚、阿尔巴尼亚、希腊、意大利、梵蒂冈、圣马力诺、马耳他、西班牙、葡萄牙、安道尔等44国</td>
            </tr>
            <tr>
              <td>中国（上海）至“一路”沿线国家出口集装箱海运量</td>
              <td style="text-align:center">&nbsp;</td>
            </tr>
            <tr>
              <td>俄远东</td>
              <td style="text-align:center">俄罗斯海参威、东方港等2港</td>
            </tr>
            <tr>
              <td>南亚</td>
              <td style="text-align:center">印度、巴基斯坦、孟加拉国、阿富汗、尼泊尔联邦民主共和国、不丹、斯里兰卡、马尔代夫等8国</td>
            </tr>
            <tr>
              <td>东南亚</td>
              <td style="text-align:center">越南、老挝、柬埔寨、泰国、马来西亚、新加坡、印度尼西亚、文莱、菲律宾、缅甸、东帝汶等11国</td>
            </tr>
            <tr>
              <td>西亚</td>
              <td
                style="text-align:center"
              >土耳其、伊朗、叙利亚、伊拉克、阿联酋、沙特阿拉伯、卡塔尔、巴林、科威特、黎巴嫩、阿曼、也门、约旦、以色列、巴勒斯坦、格鲁吉亚、亚美尼亚、阿塞拜疆等18国</td>
            </tr>
            <tr>
              <td>欧洲</td>
              <td
                style="text-align:center"
              >英国、爱尔兰、荷兰、比利时、卢森堡、法国、摩纳哥、冰岛、法罗群岛、丹麦、挪威、瑞典、芬兰、波兰、捷克、斯洛伐克、匈牙利、德国、奥地利、瑞士、列支敦士顿、爱沙尼亚、拉脱维亚、立陶宛、白俄罗斯、乌克兰、摩尔多瓦、塞尔维亚、黑山、克罗地亚、斯洛文尼亚、波黑、马其顿、罗马尼亚、保加利亚、阿尔巴尼亚、希腊、意大利、梵蒂冈、圣马力诺、马耳他、西班牙、葡萄牙、安道尔等44国，以及俄罗斯圣彼得堡、新罗西斯克等2港</td>
            </tr>
            <tr>
              <td>大洋洲</td>
              <td style="text-align:center">澳大利亚、新西兰等2国</td>
            </tr>
            <tr>
              <td>北非</td>
              <td style="text-align:center">埃及等1国</td>
            </tr>
            <tr>
              <td>中国自“一路”沿线国家进口煤炭海运量</td>
              <td style="text-align:center">&nbsp;</td>
            </tr>
            <tr>
              <td>东南亚</td>
              <td style="text-align:center">印度尼西亚、越南、菲律宾等3国</td>
            </tr>
            <tr>
              <td>大洋洲</td>
              <td style="text-align:center">澳大利亚等1国</td>
            </tr>
            <tr>
              <td>中国自“一路”沿线国家进口铁矿石海运量</td>
              <td style="text-align:center">&nbsp;</td>
            </tr>
            <tr>
              <td>大洋洲</td>
              <td style="text-align:center">澳大利亚等1国</td>
            </tr>
            <tr>
              <td>欧洲</td>
              <td style="text-align:center">乌克兰等1国</td>
            </tr>
            <tr>
              <td>亚洲</td>
              <td style="text-align:center">印度尼西亚、马来西亚、印度、伊朗等4国</td>
            </tr>
            <tr>
              <td>中国自“一路”沿线国家进口原油海运量</td>
              <td style="text-align:center">&nbsp;</td>
            </tr>
            <tr>
              <td>西亚、北非</td>
              <td
                style="text-align:center"
              >伊朗、阿联酋、巴林、阿曼、卡塔尔、沙特阿拉伯、伊拉克、科威特、也门、约旦、叙利亚、黎巴嫩、以色列、巴勒斯坦、埃及等15国</td>
            </tr>
          </tbody>
        </table>

        <!-- “一带一路”集装箱海运量指数 -->
        <table>
          <thead>
            <tr>
              <th>&nbsp;</th>
              <th style="text-align:center">“一带一路”集装箱海运量指数</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>指标</td>
              <td style="text-align:center">指标范围</td>
            </tr>
            <tr>
              <td>蒙俄</td>
              <td style="text-align:center">蒙古、俄罗斯联邦等2国</td>
            </tr>
            <tr>
              <td>中亚</td>
              <td style="text-align:center">哈萨克斯坦、吉尔吉斯斯坦、塔吉克斯坦、乌兹别克斯坦、土库曼斯坦等5国</td>
            </tr>
            <tr>
              <td>东南亚</td>
              <td style="text-align:center">越南、老挝、柬埔寨、泰国、马来西亚、新加坡、印度尼西亚、文莱、菲律宾、缅甸、东帝汶等11国</td>
            </tr>
            <tr>
              <td>欧洲</td>
              <td
                style="text-align:center"
              >英国、爱尔兰、荷兰、比利时、卢森堡、法国、摩纳哥、冰岛、法罗群岛、丹麦、挪威、瑞典、芬兰、波兰、捷克、斯洛伐克、匈牙利、德国、奥地利、瑞士、列支敦士顿、爱沙尼亚、拉脱维亚、立陶宛、白俄罗斯、乌克兰、摩尔多瓦、塞尔维亚、黑山、克罗地亚、斯洛文尼亚、波黑、马其顿、罗马尼亚、保加利亚、阿尔巴尼亚、希腊、意大利、梵蒂冈、圣马力诺、马耳他、西班牙、葡萄牙、安道尔等44国</td>
            </tr>
            <tr>
              <td>中国（上海）至“一路”沿线国家出口集装箱海运量</td>
              <td style="text-align:center">&nbsp;</td>
            </tr>
            <tr>
              <td>俄远东</td>
              <td style="text-align:center">俄罗斯海参威、东方港等2港</td>
            </tr>
            <tr>
              <td>南亚</td>
              <td style="text-align:center">印度、巴基斯坦、孟加拉国、阿富汗、尼泊尔联邦民主共和国、不丹、斯里兰卡、马尔代夫等8国</td>
            </tr>
            <tr>
              <td>东南亚</td>
              <td style="text-align:center">越南、老挝、柬埔寨、泰国、马来西亚、新加坡、印度尼西亚、文莱、菲律宾、缅甸、东帝汶等11国</td>
            </tr>
            <tr>
              <td>西亚</td>
              <td
                style="text-align:center"
              >土耳其、伊朗、叙利亚、伊拉克、阿联酋、沙特阿拉伯、卡塔尔、巴林、科威特、黎巴嫩、阿曼、也门、约旦、以色列、巴勒斯坦、格鲁吉亚、亚美尼亚、阿塞拜疆等18国</td>
            </tr>
            <tr>
              <td>欧洲</td>
              <td
                style="text-align:center"
              >英国、爱尔兰、荷兰、比利时、卢森堡、法国、摩纳哥、冰岛、法罗群岛、丹麦、挪威、瑞典、芬兰、波兰、捷克、斯洛伐克、匈牙利、德国、奥地利、瑞士、列支敦士顿、爱沙尼亚、拉脱维亚、立陶宛、白俄罗斯、乌克兰、摩尔多瓦、塞尔维亚、黑山、克罗地亚、斯洛文尼亚、波黑、马其顿、罗马尼亚、保加利亚、阿尔巴尼亚、希腊、意大利、梵蒂冈、圣马力诺、马耳他、西班牙、葡萄牙、安道尔等44国，以及俄罗斯圣彼得堡、新罗西斯克等2港</td>
            </tr>
            <tr>
              <td>大洋洲</td>
              <td style="text-align:center">澳大利亚、新西兰等2国</td>
            </tr>
            <tr>
              <td>北非</td>
              <td style="text-align:center">埃及等1国</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div v-if="firstmsrShow" id="STI-4" style="display: block; box-sizing: border-box; line-height: 30px;box-shadow: 0px 0px 4px #888888;">
      <div style="color:#4996dd;font-size:15px;font-weight: 600;cursor: pointer;" @click="back">返回</div>
      <h3 style="text-align:center">指数简介</h3>
      <div class="video">
        <!-- <embed width="97%" height="350" type="application/x-shockwave-flash" loop="-1" autostart="false" src="http://static.youku.com/v/swf/qplayer.swf?winType=adshow&VideoIDS=XMTM2NjkzMTc4OA&isAutoPlay=false&isShowRelatedVideo=false&imglogo="> -->
      </div>
      <div class="text-content">
        <p class="text1" style="font-size: 15px;font-weight: bold;">
          &nbsp;&nbsp;&nbsp;&nbsp;海上丝路贸易指数（Maritime Silk Road Trade
          Index，简称STI）是一套月度发布的贸易发展指数体系，由进出口贸易指数、出口贸易指数和进口贸易指数构成，并从总体贸易指数、区域贸易指数、特类贸易指数等不同方面衡量中国对外经贸发展水平、反映中国对外贸易发展变化趋势。
          <br />
          <br />指数架构：
        </p>
        <!-- <img src="http://www.msri.cn:80/resources/xy/img/stiIntro.png"/> -->
        <span class="textTitle in2">&nbsp;&nbsp;&nbsp;&nbsp;总体贸易指数：</span>
        <span class="in3">&nbsp;&nbsp;包括进出口贸易指数、出口贸易指数、进口贸易指数，反映我国总体进出口、出口、进口贸易发展状况；</span>
        <p></p>
        <span class="textTitle in2">&nbsp;&nbsp;&nbsp;&nbsp;区域贸易指数：</span>
        <span
          class="in3"
        >&nbsp;&nbsp;包括亚洲贸易指数、欧洲贸易指数、非洲贸易指数、北美洲贸易指数、拉丁美洲贸易指数、大洋洲贸易指数，反映我国与亚洲、非洲、欧洲等全球6个大洲的进出口、出口、进口贸易发展状况；</span>
        <p></p>
        <span class="textTitle in2">&nbsp;&nbsp;&nbsp;&nbsp;特类贸易指数：</span>
        <span
          class="in3"
        >&nbsp;&nbsp;包括17+1贸易指数、“一带一路”沿线国家贸易指数、美国贸易指数、水路运输贸易指数，分别反映我国与中东欧国家、我国与“一带一路”沿线国家、我国与美国以及我国水路运输方式的进出口、出口、进口贸易发展状况；其中：水路运输贸易指数又能反映我国水运集装箱类、水运散货类、水运液货类进出口、出口、进口贸发展状况。</span>
        <p></p>
        <p class="text1">海上丝路贸易指数编制：</p>
        <p class="textTitle">指数基期</p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;海上丝路贸易指数以2015年3月为基期，基点为100。</p>
        <p class="textTitle">数据来源</p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;海上丝路贸易指数的数据来源于海关月度进出口贸易数据。</p>
        <p class="textTitle">编制方法</p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;海上丝路贸易指数采用国际通行的发展指数计算方法进行编制，并采用初值、终值相结合的发布方式。</p>
        <p class="textTitle">指数发布</p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;海上丝路贸易指数初值的发布时间为每月9日；终值的发布时间为每月27日，遇法定节假日顺延。</p>
      </div>
    </div>
    <div v-if="lastmsrShow" class="tab-pane fade" id="CCTI-4" style="display: block; box-sizing: border-box; line-height: 30px;box-shadow: 0px 0px 12px #888888;">
			<div style="color:#4996dd;font-size:15px;font-weight: 600;cursor: pointer;" @click="back">返回</div>
      <h3 style="text-align:center">指数简介</h3>
				<div class="text-content">
					<p class="text1" style="font-size: 15px;font-weight: bold;">
						&nbsp;&nbsp;&nbsp;&nbsp;17+1贸易指数每月从中东欧17国和分国别两个粒度发布中国与中东欧进出口贸易指数、出口贸易指数和进口贸易指数，用以衡量中国与中东欧17个国家间的贸易发展水平，反映中国与中东欧17个国家间的贸易发展变化趋势。
						<br><br>
						指数构成：</p>
					<span class="textTitle in2">&nbsp;&nbsp;&nbsp;&nbsp;中东欧17国:</span><span
						class="in3">&nbsp;&nbsp;包括进出口贸易指数、出口贸易指数、进口贸易指数，反映我国与中东欧17个国家间的总体进出口、出口、进口贸易发展状况；</span>
					<p></p>
					<span class="textTitle in2">&nbsp;&nbsp;&nbsp;&nbsp;分国别:</span><span
						class="in3">&nbsp;&nbsp;分别反映我国与阿尔巴尼亚、爱沙尼亚、保加利亚、波黑、波兰、黑山、捷克、克罗地亚、拉脱维亚、立陶宛、罗马尼亚、北马其顿、塞尔维亚、斯洛伐克、斯洛文尼亚、匈牙利、希腊等中东欧国家之间的进出口、出口、进口贸易发展状况。</span>
					<p></p>
					<p class="text1">17+1贸易指数编制：</p>
					<p class="textTitle">指数基期</p>
					<p>&nbsp;&nbsp;&nbsp;&nbsp;17+1贸易指数以2015年3月为基期，基期指数为100点。</p>
					<p class="textTitle">数据来源</p>
					<p>&nbsp;&nbsp;&nbsp;&nbsp;17+1贸易指数数据来源于海关月度进出口贸易数据。</p>
					<p class="textTitle">编制方法</p>
					<p>&nbsp;&nbsp;&nbsp;&nbsp;17+1贸易指数采用国际通行的发展指数计算方法进行编制。</p>
					<p class="textTitle">指数发布</p>
					<p>&nbsp;&nbsp;&nbsp;&nbsp;17+1贸易指数由宁波航运交易所在每月27日对外发布，指数发布日遇法定节假日顺延。</p>
				</div>
			</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      oborShow: false,
      firstmsrShow: false,
      lastmsrShow: false
    };
  },
  created() {
    if (this.$route.query.param === "obor") {
      this.init()
      this.oborShow = true;
    }else if(this.$route.query.param === "first") {
      this.init()
      this.firstmsrShow = true;
    }else if(this.$route.query.param === "last") {
      this.init()
      this.lastmsrShow = true;
    }
  },
  methods: {
    init(){
      this.oborShow = false,
      this.firstmsrShow = false,
      this.lastmsrShow = false
    },
    back() {
      this.$router.go(-1); //返回上一层
    }
  }
};
</script>

<style lang='less' scoped>
@import "../assets/css/editormd.preview.css";
@import "../assets/css/STI.css";
.tab-content table{
  margin: 20px auto 50px auto;
}
.tab-content thead tr{
  color: #000;
}
</style>